module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_alpthal-73e96047fb7b71537546ceb8ff4ac032.png";